<template>
  <q-tab-panel :name="name" :class="{ 'no-padding': noPadding }">
    <slot />
  </q-tab-panel>
</template>

<script>
export default {
  name: 'TabPanel',
  props: {
    name: {
      type: String,
      required: true,
    },
    noPadding: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.no-padding {
  padding: 0;
}
</style>
